import React from 'react';

type Props = {
  active?: boolean;
  accentColor?: string;
  className?: string;
};

const BellNotifyIcon = ({ active = false, accentColor = '#F59E0B', className }: Props) => {
  const bellColor = active ? accentColor : 'white';

  return (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M12.01 5.5C9.36 5.5 7.21 7.65 7.21 10.3V12.16C7.21 12.55 7.05 13.15 6.86 13.48L5.93 15.01C5.37 15.96 5.76 16.99 6.8 17.34C10.25 18.5 13.98 18.5 17.43 17.34C18.4 17.02 18.83 15.89 18.3 15.01L17.37 13.48C17.13 13.15 16.97 12.55 16.97 12.16V10.3C16.97 7.67 14.81 5.5 12.01 5.5Z"
        stroke={bellColor}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        fill={active ? bellColor : 'none'}
      />
      <path
        d="M13.5 5.76C13.25 5.69 12.99 5.63 12.73 5.6C11.96 5.5 11.22 5.56 10.53 5.76C10.76 5.17 11.34 4.75 12.01 4.75C12.68 4.75 13.26 5.17 13.5 5.76Z"
        stroke={bellColor}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={active ? bellColor : 'none'}
      />
      <path
        d="M14.42 17.62C14.42 18.95 13.34 20.03 12.01 20.03C11.35 20.03 10.74 19.76 10.31 19.32C9.88 18.89 9.61 18.28 9.61 17.62"
        stroke={bellColor}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        fill="none"
      />
    </svg>
  );
};

export default BellNotifyIcon;
